import { render } from "./ProductItemTest.vue?vue&type=template&id=51f9c36a"
import script from "./ProductItemTest.vue?vue&type=script&lang=js"
export * from "./ProductItemTest.vue?vue&type=script&lang=js"

import "./ProductItemTest.vue?vue&type=style&index=0&id=51f9c36a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__